import { SignUpHeader } from '../../components/SignUpHeader';
import { ProJoinForm } from '../../components/ProJoinForm';
import { RedirectIfAuthed } from '../../../lib/use-auth';

/**
 * Invite-only account creation. Reached via the tokenized link
 * /professional/join/:token sent to approved applicants / off-platform
 * recruits. Skips the application form and goes straight to creating the
 * account, then into the existing onboarding journey. No Customer/Professional
 * tabs here — this is a targeted invite, not the public entry point.
 */
export default function ProJoinPage() {
  return (
    <RedirectIfAuthed>
      <div className="size-full bg-white flex flex-col min-h-screen">
        <div className="pt-0">
          <SignUpHeader
            mode="signin"
            isProfessional={true}
            showSwitchButton={false}
          />
        </div>
        <div className="flex-1 flex flex-col items-center justify-center py-6 md:py-12 px-4">
          <ProJoinForm />
        </div>
      </div>
    </RedirectIfAuthed>
  );
}
